/* eslint-disable no-plusplus */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */

import { fabric } from 'fabric';
import { generateId } from '../../utils';
import { FABRIC_CUSTOM_OBJECT } from '../../utils/constants';

const createComponent = (root) => {
  const width = root.width + root.strokeWidth;
  const height = root.height + root.strokeWidth;

  const EPS = 15;

  const defaultStyle = {
    fill: '#444',
    strokeWidth: '0',
    stroke: '#444',
    originX: 'center',
    originY: 'center',
    objectCaching: false,
    top: root.isAudio ? 0 : root.height / 2 - EPS,
  };

  const container = new fabric.Rect({
    width,
    height,
    left: -root.width / 2 - root.strokeWidth,
    top: -root.height / 2 - root.strokeWidth,
    fill: root.isAudio ? root.fill : '#fff',
    stroke: root.stroke,
    strokeWidth: root.strokeWidth,
    strokeDashArray: root.strokeDashArray,
    strokeLineCap: root.strokeLineCap,
    rx: root.rx,
    ry: root.ry,
    objectCaching: false,
  });

  const playButton = new fabric.Path(
    'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z',
    {
      ...defaultStyle,
      width: 22,
      height: 22,
      left: -width / 2 + 22 + root.strokeWidth / 2,
    },
  );

  const progressBar = new fabric.Rect({
    ...defaultStyle,
    fill: '#fff',
    strokeWidth: 0,
    rx: 3,
    ry: 3,
    height: 4,
  });

  const zoomButton = new fabric.Path(
    'M3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm2 10H3v4c0 1.1.9 2 2 2h4v-2H5v-4zm14 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-16h-4v2h4v4h2V5c0-1.1-.9-2-2-2z',
    {
      ...defaultStyle,
      width: 20,
      height: 20,
      left: width / 2 - 20 - root.strokeWidth / 2,
    },
  );

  const soundButton = new fabric.Path(
    'M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z',
    {
      ...defaultStyle,
      width: 20,
      height: 19.54,
      left: zoomButton.left - zoomButton.width * 1.7,
    },
  );

  const progressBarWidth =
    width - playButton.width * 2 - zoomButton.width * 2 - soundButton.width * 2 - root.strokeWidth;
  progressBar.set({
    width: progressBarWidth,
    left: playButton.left + playButton.width + progressBarWidth / 2,
  });

  const circle = new fabric.Circle({
    ...defaultStyle,
    radius: 7,
    left: progressBar.left - progressBar.width * 0.2,
  });

  const subContainer = new fabric.Rect({
    width,
    height: EPS * 2 + root.strokeWidth,
    left: -root.width / 2 - root.strokeWidth,
    top: root.height / 2 - EPS * 2 - root.strokeWidth,
    fill: root.fill,
    stroke: root.stroke,
    strokeWidth: root.strokeWidth,
    strokeDashArray: root.strokeDashArray,
    strokeLineCap: root.strokeLineCap,
    objectCaching: false,
    visible: root.isAudio ? false : true,
  });

  return [container, subContainer, playButton, progressBar, circle, zoomButton, soundButton];
};

fabric.AudioVideo = fabric.util.createClass(fabric.Rect, {
  initialize(options) {
    options || (options = {});
    this.callSuper('initialize', options);
    this.set('name', options.name);
    this.set('id', options.id || generateId());
    this.set('type', FABRIC_CUSTOM_OBJECT.audioVideo);
    this.set('isAudio', options.isAudio);
    this.on('scaling', () => {
      this.set({
        width: this.width * this.scaleX,
        height: this.height * this.scaleY,
        scaleX: 1,
        scaleY: 1,
        flipX: false,
        flipY: false,
      });
    });
  },
  updateClipPath: function () {
    const clipPathObj = new fabric.Rect({
      width: this.width,
      height: this.height,
      left: -this.width / 2,
      top: -this.height / 2,
      strokeWidth: 0,
    });
    this.noScaleCache = false;
    this.clipPath = clipPathObj;
  },
  toObject() {
    this.updateClipPath();
    return fabric.util.object.extend(this.callSuper('toObject'), {
      id: this.get('id'),
      name: this.get('name'),
      isAudio: this.get('isAudio'),
    });
  },
  toSVG() {
    this.updateClipPath();
    const components = createComponent(this);
    let svgString = '';
    components.forEach((c) => {
      svgString += c.toSVG();
    });
    return svgString;
  },
  _render(ctx) {
    this.updateClipPath();
    const components = createComponent(this);
    components.forEach((component) => component.render(ctx));
  },
});

fabric.AudioVideo.fromObject = function (options, callback) {
  return callback(new fabric.AudioVideo(options));
};

export function createCustomObj() {
  const rect = new fabric.AudioVideo({
    id: generateId(),
    name: 'Audio',
    width: 300,
    height: 30,
    fill: '#e6e6e6',
    stroke: '#444',
    strokeWidth: 1,
    objectCaching: false,
    isAudio: true,
  });
  return rect;
}

window.fabric.AudioVideo = fabric.AudioVideo;

export default fabric.AudioVideo;
